import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = {
  accessToken: null,
  isLoggedIn: false,
  userConfigs: null,
  hasMultilogin: false,
  userServiceProfile: {
    redeConexa: false,
    saas: false,
    whiteLabel: false,
  },
};

const authModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default authModule;
